import React, { useState } from 'react';
import {
  PaymentElement,
  Elements,
  useStripe,
  useElements,
} from '@stripe/react-stripe-js';

export const AfrekenFormulier = () => {
  const stripe = useStripe();
  const elements = useElements();

  const [errorMessage, setErrorMessage] = useState('');
  const [emailInput] = useState('');
      const [isLoading, setIsLoading] = useState(false);



  const backendUrl = '';

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js hasn't yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    setIsLoading(true);

    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        // Make sure to change this to your payment completion page
        return_url: "https://verkoop.scoutssintgoedele.be/confirmatie",
      },
    });


  };

  return (
    <form onSubmit={handleSubmit} className='px-4'>
      <h1>Afrekenen</h1>

    

      <PaymentElement />
      <button type="submit" disabled={isLoading}>
        Pay
      </button>

      {/* Show error message to your customers */}
      {errorMessage && <div>{errorMessage}</div>}
    </form>
  );
};